import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2b829938&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "@/components/pages/transfersPage/components/transfersHistory/styles/table.scoped.scss?vue&type=style&index=0&id=2b829938&prod&lang=scss&scoped=true&external"
import style1 from "@/components/pages/transfersPage/components/transfersHistory/styles/scoped.scss?vue&type=style&index=1&id=2b829938&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b829938",
  null
  
)

export default component.exports